import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { Button, Dialog } from '../../../components/ui';
import { USER_STATUS_MESSAGES } from '../config/userStatusCopy';

function getDisplayName(user) {
  return (
    [user?.first_name, user?.last_name].filter(Boolean).join(' ')
    || user?.username
    || 'this user'
  );
}

export default function UserStatusDialog({
  open,
  user,
  activating = false,
  onClose,
  onConfirm,
  isSubmitting = false,
}) {
  const displayName = getDisplayName(user);
  const title = activating
    ? USER_STATUS_MESSAGES.activateTitle
    : USER_STATUS_MESSAGES.deactivateTitle;
  const bodySuffix = activating
    ? USER_STATUS_MESSAGES.activateBody
    : USER_STATUS_MESSAGES.deactivateBody;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      actions={
        <>
          <Button variant="secondary" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            variant={activating ? 'primary' : 'destructive'}
            loading={isSubmitting}
            onClick={onConfirm}
          >
            {activating ? 'Activate' : 'Deactivate'}
          </Button>
        </>
      }
    >
      <Typography>
        Are you sure you want to {activating ? 'activate' : 'deactivate'} user{' '}
        <strong>{displayName}</strong>? They {bodySuffix}
      </Typography>
    </Dialog>
  );
}

UserStatusDialog.propTypes = {
  open: PropTypes.bool,
  user: PropTypes.object,
  activating: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  isSubmitting: PropTypes.bool,
};
